<template>
    <div class="d-flex justify-content-center align-items-center logo-container">
        <!-- <img v-if="brandContainer && brandName === client" :src="require(`../../../assets/brand_logo/${client}.png`)" height="100% " alt="client-image"> -->
        <img v-if="placeholder || !imgSrc" src="../../../assets/logo/placeholder.svg" :height="imageHeight" alt="brand-logo">
        <div v-if="imgSrc" class="container">
            <img :src="imgSrc">
        </div>
    </div>
</template>
<script>
export default {
    name: "LogoContainer",
    props: {
        imgSrc: String,
        placeholder: Boolean,
        imageHeight: Number,
        brandContainer: {
            type: Boolean,
            default: false
        },
        brandName: String
    },
    data() {
        return {
            client: JSON.parse(localStorage.reviewUserData).data.client
        }
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    max-width: 183px !important;
    height: 170px;
    display: flex;
    justify-content: center;
    padding: 6px;
}

.container img {
    mix-blend-mode: multiply;
    width: 100%;
    max-width: 180px !important;
    height: auto;
    max-height: 168px;
    object-fit: contain;
}
</style>